import { Component, OnInit, ViewChild, ElementRef, NgZone, Renderer, AfterViewInit, ComponentRef, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MapsAPILoader } from '@agm/core';
import { environment } from '../../../environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from '../../models/app.state';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { HttpService } from '../../service/http.service';
import { PostFilterService } from '../../service/post-filter.service';
import { HomeComponent } from '../home/home.component';
import { eventEmitterService } from '../../service/eventEmitter.service';
import { HttpClient } from '@angular/common/http';
import { BUILDING_RESET } from 'src/app/actions/building.actions';
declare var $: any;
declare var window:any; 

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit, AfterViewInit, OnDestroy {
  inputAddress: any;
  successMessage: string;
  reportCoop: any;
  coords: { lat: number; lng: number; };
  imageUrl: string;
  unregisteredAddress: any;
  modalWindow: any;
  address:any = {};
  alert: string;

  modalTarget: string;
  errorState: boolean;
  ModalTrigger: boolean;
  error: any;
  addressInput;
  place: google.maps.places.PlaceResult;
  isLoadingActive = false;
  isSuccess = false;

  emailInvalid = false;
  commentInvalid = false;
  submitted:boolean = false;
  clientUrl: string = environment.clientUrl;
  

  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;

  homeComponentRef: ComponentRef<HomeComponent>;

  @ViewChild('submitbuild', { static: false })
  public submit: ElementRef;

  @ViewChild('videoElement', { static: false })
  public videoElement: ElementRef;
  buildingCount;
  residentCount;

  

  constructor(private router: Router,
              private mapsAPILoader: MapsAPILoader,
              private ngZone: NgZone,
              private renderer: Renderer,
              private _fb: FormBuilder,
              private httpService: HttpService,
              private _http: HttpClient,
              private emitter: eventEmitterService,
              private route: ActivatedRoute,
              private store: Store<AppState>,
              private param: PostFilterService) { }

  ngOnInit() {

  this.store.dispatch({type: BUILDING_RESET, payload: []});
  
    var bannerHeight;
    if ($(document).innerWidth() < 1200){
      bannerHeight = ($('.banner').height() + 400);
      $('.pageVideoWrap video').css('height', bannerHeight);
    }
    else{ 
      $('.pageVideoWrap video').css('height', 'auto');          
    }
    $(window).on('load ready resize', function () {
       if ($(document).innerWidth() < 1200){
         bannerHeight = ($('.banner').height() + 400);
         $('.pageVideoWrap video').css('height', bannerHeight);
       }
       else{ 
         $('.pageVideoWrap video').css('height', 'auto');          
       }
    })
    this.httpService.getBuildingCount().subscribe((data)=>{
      this.buildingCount = data.count;
      this.residentCount = data.count * 175;
    });


   

  this.emitter.eventEmit$.subscribe((data)=>{
    if(data.homeReset){
      this.alert = null;
    }else if(data.isSignupAlert){
      this.alert = "Please enter your address to proceed with sign up";
    }
  })

  }

  ngAfterViewInit(){

      $(document).ready(function(){
        $('.modal-backdrop.fade.in').remove();

    });
        let modalParam = this.route.queryParams;
        this.error = this.route.snapshot.queryParams['error'];
        let deactivatedUser = this.route.snapshot.queryParams['exist'];
        console.log(modalParam, this.error, 'hello')
        if(this.error == "err" && !deactivatedUser){
             //$("#loginForm").modal('show');
             this.error = "Please create your account";
        }else if(this.error == "err" && deactivatedUser){
             //$("#loginForm").modal('show');
             this.error = "Please activate your account";
        }
    
    
          this.param.currentMessage2.subscribe((res)=>{
            if(res == 'open'){
             $(document).ready(function(){
                $('#loginForm').modal('show');
              })
    
    
            }
          }).unsubscribe();

          setTimeout(()=>{
            $(document).ready(function(){
              window.Intercom("boot", {
                app_id: "kgx05kdo",
              });
            
          });
          },3000)
    
      }


  modalTriggerMethod() {
    $('#loginForm').modal('show');
  }

  ngOnDestroy(){

        if(window.Intercom){
          window.Intercom("hide");        
        }

         $('#loginForm').modal('hide');
        if(this.homeComponentRef){
          this.homeComponentRef.destroy();
        }
    
  }

  openExternal(link) {
    window.open(link, '_blank');
  }
}
